exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".LayoutPanelDropTarget {\n  width: 100%;\n  height: 100%;\n\n  opacity: 1;\n  -webkit-transition: 0.3s all ease;\n  transition: 0.3s all ease;\n}\n\n.LayoutPanelDropTarget.hovered {\n  opacity: 0.5;\n  cursor: copy;\n}\n", ""]);
